import './NotesPage.css';

interface HistoricalNoteProps {
  date: string;
  user: string;
  subject: string;
  content: string;
}

export default function Note(props: HistoricalNoteProps) {

  const { date, user, subject, content} = props;

  return (
    <div className="note-container">
      <div className="note-header">
        <h3>{subject}</h3>
        <span className="note-date">{date}</span>
      </div>
      <div className="note-body">{content}</div>
      <span className="note-attribution">-- {user}</span>
    </div>
  );
}
